import { Component, OnInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/app.service';
import { TipoDocumentosService } from 'src/app/services/tipo-documentos.service';
import { DadosCargasService } from 'src/app/services/dados-cargas.service';

@Component({
    selector: 'app-modal-cadastro-tipo-documentos',
    templateUrl: './modal-cadastro-tipo-documentos.component.html',
    providers: [TipoDocumentosService]
})

export class ModalCadastroTipoDocumentosComponent implements OnInit {

    modalRef: NgbModalRef;
    public tipoDocumento: any;

    constructor(
        private spinner: NgxSpinnerService,
        public toastrService: ToastrService,
        private appService: AppService,
        private tipoDocumentosService: TipoDocumentosService,
        private dadosCargasService: DadosCargasService,
    ) {

    }

    popularNovoTipoDocumento() {
        this.tipoDocumento = {
            nome: '',
        };
    }

    ngOnInit(): void {
        this.popularNovoTipoDocumento();
    }

    cadastrar() {
        this.add(this.tipoDocumento);
    }

    add(tipoDocumento) {
        this.spinner.show();
        this.toastrService.clear();
        this.tipoDocumentosService.add(tipoDocumento)
            .subscribe(res => {
                this.toastrService.success("Tipo de documento cadastrado.", "Sucesso");
                this.modalRef.close({ result: true, page: this.modalRef.componentInstance.page, acao: 'cadastrado' });
            }, error => {
                if (error && error.errors) {
                    this.toastrService.error(error.errors[0], 'Atenção', { timeOut: 10000 });
                }
                else {
                    this.toastrService.error('Não foi possível cadastrar o tipo de documento!', 'Atenção', { timeOut: 10000 });
                }
                this.spinner.hide();
            });
    }

    close() {
        this.modalRef.close();
    }

    dismiss() {
        this.modalRef.dismiss();
    }
}